import React from "react";
import { FaAddressBook, FaPhoneSquareAlt, FaPhoneVolume } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";

const Contact = () => {
  return (
    <div className="min-h-screen mt-20 bg-gradient-to-br from-blue-50 to-white px-5 py-10">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between bg-white shadow-lg rounded-2xl overflow-hidden">
        {/* Left Side - Info */}
        <div className="md:w-1/2 w-full bg-gradient-to-br from-[#319fb5] to-[#78ffd6] text-white p-10 space-y-6 rounded-tr-3xl rounded-br-3xl shadow-lg">
          <h2 className="text-3xl font-bold font-serif">Let’s Talk</h2>
          <p className="text-sm opacity-90 leading-relaxed">
            MindCare is committed to supporting your mental well-being. Whether you have questions, need help, or just want to talk, we’re here for you.
          </p>
          <ul className="text-sm space-y-2 pt-4">
            <div className="flex items-center gap-3">
              <FaAddressBook /><li> #179, Kothari Nagar, Singanallur, Coimbatore - 641 005. INDIA</li>
            </div>
            <div className="flex items-center gap-3">
              <FaPhoneSquareAlt /><li>+91 8794267636</li>
            </div>
            <div className="flex items-center gap-3">
              <IoMdMail /><li>help@mindcare.com</li>
            </div>
          </ul>
        </div>
        


        {/* Right Side - Form */}
        <div className="md:w-1/2 w-full p-10">
          <h3 className="text-2xl font-semibold text-[#0f766e] mb-4">Contact</h3>
          <form className="space-y-4">
            <div className="flex flex-col md:flex-row gap-4">
              <input
                type="text"
                placeholder="First Name"
                className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-[#0f766e] outline-none"
              />
              <input
                type="text"
                placeholder="Last Name"
                className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-[#0f766e] outline-none"
              />
            </div>
            <div className="flex flex-col md:flex-row gap-4">
              <input
                type="email"
                placeholder="Email"
                className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-[#0f766e] outline-none"
              />
              <input
                type="tel"
                placeholder="Phone"
                className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-[#0f766e] outline-none"
              />
            </div>
            <input
              type="text"
              placeholder="Address"
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-[#0f766e] outline-none"
            />
            <input
              type="text"
              placeholder="Subject"
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-[#0f766e] outline-none"
            />
            <textarea
              rows="4"
              placeholder="Message"
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-[#0f766e] outline-none"
            ></textarea>
            <button
              type="submit"
              className="w-full bg-[#22c5b7] text-white py-3 rounded-full hover:bg-[#0ea5e9] transition duration-300"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
